import script from "./PhotosView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhotosView.vue?vue&type=script&setup=true&lang=ts"

import "./PhotosView.vue?vue&type=style&index=0&id=c2685ecc&lang=scss"

const __exports__ = script;

export default __exports__